<template>
  <div class="view-detail">
    <ViewArticle
      v-if="articleId"
      :catalogAlisa="catalogAlisa"
      :articleId="articleId"
      :hiddenTitle="true"
      :breadcrumbs="[
        { text: '首页', to: '/' },
        { text: '技能培训', to: '/skillTrain' },
        { text: '师资培训', to: '/skillTrain/teacherTraining' }
      ]"
    />
    <UiEmpty v-if="loadFinished && !loadError && !articleId" />
    <UiEmpty v-if="loadFinished && loadError" type="error" />
  </div>
</template>

<script>
import { cmsCatalogContentList } from '@/api/index';

export default {
  name: 'Index',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    catalogAlisa: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      articleId: null,
      loadFinished: false,
      loadError: false,
    };
  },
  watch: {
    catalogAlisa(val) {
      this.getData(val);
    },
  },
  created() {
    this.getData(this.catalogAlisa);
  },
  methods: {
    getData(catalogAlisa) {
      if (!catalogAlisa) {
        this.loadFinished = true;
        this.articleId = null;
        return;
      }
      cmsCatalogContentList({
        pageNum: 1,
        pageSize: 1,
        catalogAlisa,
      }).then((res) => {
        if (res.data.contentList && res.data.contentList.length) {
          this.articleId = res.data.contentList[0].contentId;
        }
      }).catch(() => {
        this.loadError = true;
      }).finally(() => {
        this.loadFinished = true;
      });
    },
  },
};
</script>

<style scoped lang="less">
.detail-wrap {
  padding: 20px 0;
}
.breadcrumb-wrap {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: #035fcf solid 1.5px;
}
.article {
  .article-top {
    margin-bottom: 20px;
    text-align: center;
    .publish-time {
      font-weight: bold;
      margin-top: 10px;
      color: grey;
    }
  }

  .article-content p {
    margin-bottom: 1em;
    text-indent: 2em;
  }
  .no-content {
    text-align: center;
    color: grey;
  }
  &::v-deep {
    img {
      max-width: 100% !important;
      height: auto !important;
    }
    p {
      word-wrap: break-word !important;
    }
  }
}
</style>
